import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {handleClickLinks} from '../../csf-ufc-fournisseur/includes/utils';
import {stopLoadingSpinner} from "../../csf-ufc-pivotal/includes/utils";
import {formatAttributeFromApi, formatPhoneNumber, formatedLongEmail} from "../utils/utils";
import CsfMembreProfileModal from "./csf-membre-profil-modal";
import CsfMembreConsentModal from "./consent/CsfMembreConsentModal";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import DrupalAccessTokenApi from "../../../js/csf/DrupalAccessTokenApi";
import CsfMembreUtils from "../utils/CsfMembreUtils";
import CsfMemberDataLayer from "../utils/CsfMembreDataLayer";
import PivotalApiEnvironments
  from "../../../js/csf/pivotal/PivotalApiEnvironments";
import CsfMembrePrintModal from "../print/CsfMembrePrintModal";
import CsfMemberEditActivitiesModal from "../csf-membre-activities/CsfMemberEditActivitiesModal";
import CsfMemberActivitiesDataLayer from "../csf-membre-activities/CsfMemberActivitiesDataLayer";

export default function CsfMembreSideMenu({
                                            apiUrl,
                                            apiEnv,
                                            urlDossierUfc,
                                            urlNotifications,
                                            checkedPrintOption = '',
                                            setCheckedPrintOption,
                                            preventRedirect = false,
                                            setRedirectionUrl = '',
                                            setShowConsentModal = null
                                          }) {

  const [accessToken, setAccessToken] = useState('');
  const [member, setMember] = useState({});
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [isError, setIsError] = useState(false);
  const [activitiesDataLayer, setActivitiesDataLayer] = useState({});
  const [ufcCase, setUfcCase] = useState({});
  const [dataLayer, setDataLayer] = useState({});
  const [shouldEmptyModal, setShouldEmptyModal] = useState(false);
  const [useConsents, setUseConsents] = useState(false);

  useEffect(() => {
    const phoneNumber = member?.Contact_Phone__Rn_Descriptor;
    const email = member?.Contact_Email__Rn_Descriptor;

    if(phoneNumber){
      setPhone(formatPhoneNumber(phoneNumber) || "");
    }

    if(email){
      setEmail(formatAttributeFromApi(email) || "");
    }
  }, [member]);

  useEffect(() => {
    fetchAccessToken();
  }, []);

  useEffect(() => {
    if (accessToken !== '') {
      getConnectedUser();
      setActivitiesDataLayer(new CsfMemberActivitiesDataLayer(apiUrl, apiEnv, accessToken));
      setDataLayer(new CsfMemberDataLayer(apiUrl, apiEnv, accessToken));
    }
  }, [accessToken]);

  useEffect(() => {
    if (!CsfMembreUtils.objectIsEmpty(member) && !CsfMembreUtils.objectIsEmpty(dataLayer)) {
      dataLayer.getMemberUFCCase(member?.Contact_Id, setUfcCase);
    }
  }, [member]);

  /*
  * Method to call drupal api to get the access token of the session.
  * */
  function fetchAccessToken() {
    const drupalAccessTokenApi = new DrupalAccessTokenApi();
    drupalAccessTokenApi.fetchPostRequest('membre')
      .then(response => {
        if (response?.api_access_token) {
          setAccessToken(response.api_access_token);
          setIsError(false);

          $('#membreActivitiesModal-side-menu').on('hidden.bs.modal', handleModalReset);
        } else {
          setIsError(true);
        }
      })
      .catch(error => {
        setIsError(true);
        console.error(error);
      });
  }

  function getConnectedUser() {
    const requestData = {
      search: 'Current_Ux_Client_User',
      searchResultsList: 'CSF_EM_Ux_Log_Contact_SRL',
    };

    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, PivotalApiEnvironments.getMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          setMember(response.payload.data.rows[0]);
          stopLoadingSpinner();
        }
        setIsError(false);
      })
      .catch(error => {
        setIsError(true);
        console.error(error);
        stopLoadingSpinner();
      });
  }

  function handleButtonClick(url) {
    if (preventRedirect) {
      setRedirectionUrl(url);
    } else {
      handleClickLinks(url)
    }
  }

  function handleModalReset() {
    setShouldEmptyModal(true);
  }

  return (
    <>
      <aside className="aside secondary non-print-wrapper">
        <div className="membre__side-menu">
          {isError === true ? (
            <div className="alert alert-danger mb-4" role="alert"
                 aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
          ) : (
            <>
              <div className="profil-box mb-4">
                <h2 className="mb-2">{window.Drupal.t('membre.menu.profil.title')}</h2>
                <div className="d-block d-md-flex d-xl-block align-items-center justify-content-between">
                  <div>
                    <p>
                      <span className="visually-hidden">{window.Drupal.t('Telephone')}:&nbsp;</span>
                      {phone || ""}
                    </p>
                    <p className="visually-hidden">
                      {window.Drupal.t('fournisseur.gestion.table.email')}:&nbsp;{email || ""}
                    </p>
                    <p aria-hidden="true">
                      <span className="d-sm-none d-xl-block"
                            dangerouslySetInnerHTML={{__html: formatedLongEmail(email.trim(), 23) || ""}}></span>
                      <span className="d-none d-sm-block d-xl-none">{email || ""}</span>
                    </p>
                  </div>
                  <button className="button btn-outlined" type="button" data-toggle="modal"
                          data-target="#membreProfilModal">{window.Drupal.t('membre.menu.profil')}</button>
                  {useConsents && (
                    <button className="button btn-outlined" type="button" data-toggle="modal"
                            data-target="#membreConsentModal">{window.Drupal.t('csf.member.menu.consent')}</button>
                  )}

                </div>
              </div>
              <CsfMembreProfileModal apiUrl={apiUrl} apiEnv={apiEnv} accessToken={accessToken} member={member}
                                     getConnectedUser={getConnectedUser}/>
            </>
          )}
          <button className="button btn-pale btn-menu btn-with-icon btn-larger w-100 d-xl-flex"
                  onClick={() => handleButtonClick(urlNotifications)}>
            <div className="icon-container">
              <i className="icon icon-menu-exclamation"><span className="d-none">&nbsp;</span></i>
            </div>
            <span>{window.Drupal.t('membre.menu.notification')}</span>
          </button>
          <button className="button btn-menu btn-with-icon w-100 d-xl-flex"
                  onClick={() => handleButtonClick(urlDossierUfc)}>
            <div className="icon-container"><i className="icon icon-menu-person"><span className="d-none">&nbsp;</span></i>
            </div>
            <span>{window.Drupal.t('membre.menu.trainingDocument')}</span>
          </button>
          <button className="button btn-menu btn-with-icon w-100 d-xl-flex"
                  type="button" data-toggle="modal" data-target="#membreActivitiesModal-side-menu">
            <div className="icon-container"><i className="icon icon-menu-file"><span
              className="d-none">&nbsp;</span></i></div>
            <span>{window.Drupal.t('membre.menu.activity')}</span>
          </button>

          <CsfMemberEditActivitiesModal
            modalKey="side-menu"
            activitiesDataLayer={activitiesDataLayer}
            ufcCase={ufcCase}
            shouldEmptyModal={shouldEmptyModal}
            setShouldEmptyModal={setShouldEmptyModal}
          />

          {useConsents && (
            <CsfMembrePrintModal
              apiUrl={apiUrl}
              apiEnv={apiEnv}
              checkedPrintOption={checkedPrintOption}
              setCheckedPrintOption={setCheckedPrintOption}
            />
          )}


        </div>
      </aside>
      <div id="member-print-wrapper" className="w-100">&nbsp;</div>

      <CsfMembreConsentModal
        apiUrl={apiUrl}
        apiEnv={apiEnv}
        setShowConsentModal={setShowConsentModal}
        setUseConsents={setUseConsents}
      />

    </>
  )
}

CsfMembreSideMenu.propTypes = {
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  urlDossierUfc: PropTypes.string,
  urlNotifications: PropTypes.string,
  checkedPrintOption: PropTypes.string,
  setCheckedPrintOption: PropTypes.func,
  preventRedirect: PropTypes.bool,
  setRedirectionUrl: PropTypes.func,
  setShowConsentModal: PropTypes.func
};
